<div [style.backgroundColor]="backgroundColor | contentBuilderColor: 'transparent'">
  @if (!(isShopLoading$ | async) || imageSrcUrl) {
    @if (displayImage) {
      <div class="lg:hidden">
        @if (shop || imageSrcUrl) {
          <app-shop-hero-image-atom
            [shop]="shop"
            [imageSrc]="imageSrcUrl ?? ''"
            [isPreorderingAllowed]="isPreorderingAllowed"
            [isBigHeaderImage]="isBigHeaderImage"
            (openParameters)="onOpenCartParameters()"
            (clickBack)="goBack()"
          ></app-shop-hero-image-atom>
        }
      </div>
    }
    <div class="px-5 py-3 lg:relative lg:z-20 lg:px-0 lg:py-0 lg:shadow lg:shadow-bottom">
      @if (shop) {
        <app-shop-informations-atom
          [shop]="shop"
          [name]="shop[shopKeys.Name]"
          [titleSize]="titleSize"
          [titleFont]="titleFont"
          [category]="shop[shopKeys.Type]?.name"
          [address]="shop[shopKeys.Venue]?.address?.street_line1"
          [postcode]="shop[shopKeys.Venue]?.address?.postal_code"
          [city]="shop[shopKeys.Venue]?.address?.city"
          [phone]="shop[shopKeys.Phone]"
          [contactEmail]="shop[shopKeys.ContactEmail]"
          [distance]="entity?.distance"
          [links]=""
          [displayCategory]="displayCategory"
          [displayAddress]="displayAddress"
          [displayMoreInfoButton]="displayMoreInfoButton"
          [displayGroupedOrderButton]="!!isGroupedOrderAllowed"
          [isPreorderingAllowed]="isPreorderingAllowed"
          [imageSrc]="imageSrcUrl"
          [shortDescription]="shop[shopKeys.ShortDescription]"
          [displayBookButton]="displayBookButton"
          [displayImage]="displayImage"
          [basketId]="(basketId$ | async) ?? ''"
          [shopNameColor]="shopNameColor"
          [textColor]="textColor"
          (showMoreClick)="openShopInformationsModal()"
          (groupOrderClick)="openGroupOrderModal()"
          (bookButtonClick)="openBookUrl()"
          (openParameters)="onOpenCartParameters()"
        >
        </app-shop-informations-atom>
      } @else if (showDesktopImageFallback) {
        <div class="hidden lg:block w-full bg-neutral-100">
          <img
            class="block h-64 w-full object-cover"
            [src]="imageSrcUrl"
            alt=""
          />
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col">
      <div class="h-40 w-full animate-pulse bg-neutral-300"></div>
      <div class="m-5">
        <div class="mb-3 h-8 w-3/4 animate-pulse bg-neutral-200"></div>
        <div class="mb-3 h-6 w-2/3 animate-pulse bg-neutral-50"></div>
        <div class="mb-3 h-6 w-1/2 animate-pulse bg-neutral-50"></div>
      </div>
    </div>
  }
</div>
